import { type Money } from "@vega-api/generated/types/money";
import { type CoreCurrency } from "@vega-core/models/money";

// Cleared MoneyField inputs hold an empty string, which the backend ignores so
// the previous amount persists. Coerce empty/invalid amounts to 0 so clearing
// the field resets the value rather than retaining the old one (VD-28160).
// An absent money object is left undefined so the field is omitted from the
// request and its existing value is preserved.
export const toMoneyWithZeroDefault = (
  money: Money | undefined,
  currency: CoreCurrency,
): Money | undefined =>
  money ? { amount: Number(money.amount) || 0, currency } : undefined;
